import { FC } from "react";
import { StyledIndicator } from "./styled";

type CountIndicatorProps = {
  count: number | string;
  isSmallIndicator?: boolean;
};

const CountIndicator: FC<CountIndicatorProps> = ({
  count,
  isSmallIndicator,
}) => {
  return (
    <StyledIndicator isSmallIndicator={isSmallIndicator}>
      {count}
    </StyledIndicator>
  );
};

export default CountIndicator;
